import type { Components } from '@mui/material/styles';

export default function MUICardActionArea(): Components['MuiCardActionArea'] {
  return {};
}
